module.exports = __webpack_public_path__ + "img/31.7c906081.jpg";